import { render } from "./UnNftBuy.vue?vue&type=template&id=673f4862"
import script from "./UnNftBuy.vue?vue&type=script&lang=js"
export * from "./UnNftBuy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__